/*eslint no-unused-vars: 0*/
// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';
import waypoint from 'waypoints/lib/jquery.waypoints.min';
import inview from 'waypoints/lib/shortcuts/inview';

// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faYelp,
} from '@fortawesome/free-brands-svg-icons';
import {
  faTimes,
  faBars,
  faStar,
  faStarHalf,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import {
  faChevronDoubleLeft,
  faAngleDown,
  faAngleUp,
  faChevronDoubleRight,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faLongArrowRight,
  faLongArrowLeft,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faExternalLinkAlt,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faAngleDown as fatAngleDown,
  faAngleUp as fatAngleUp,
  faPlus,
  faMinus,
  faAngleRight,
  faAngleLeft,
  faTimes as fatTimes,
} from '@fortawesome/pro-light-svg-icons';

// add the imported icons to the library
library.add(
  faFacebookF,
  faTwitter,
  faInstagram,
  faYelp,
  faBars,
  faTimes,
  faLongArrowRight,
  faExternalLinkAlt,
  faLongArrowLeft,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faSearch,
  faAngleDown,
  fatAngleDown,
  fatAngleUp,
  faAngleUp,
  faPlus,
  faMinus,
  faAngleRight,
  faAngleLeft,
  fatTimes,
  faStar,
  faStarHalf,
  faChevronDoubleLeft,
  faChevronDoubleRight
);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents();
});



// WEBPACK FOOTER //
// ./scripts/main.js